import React from 'react';

const SubscriptionDisabledModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white max-w-md w-full p-6">
                {/* Header */}
                <div className="flex justify-between items-start mb-6">
                    <div>
                        <h2 className="font-sans text-2xl font-medium text-[#1b263b] mb-2">
                            Subscription Temporarily Disabled
                        </h2>
                        <p className="font-sans text-base leading-relaxed text-neutral-900">
                            Subscription purchases are currently disabled while we set up our payment system. 
                            Please check back soon!
                        </p>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-neutral-900 hover:opacity-60 transition-opacity duration-120 font-mono text-lg border-none bg-transparent p-0 m-0"
                    >
                        ×
                    </button>
                </div>

                {/* Content */}
                <div className="mb-6">
                    <div className="bg-neutral-50 p-4 hairline">
                        <p className="font-sans text-sm text-neutral-900 mb-2">
                            <strong>What this means:</strong>
                        </p>
                        <ul className="font-sans text-sm text-neutral-900 space-y-1">
                            <li>• You can still use the free plan with 4 recipes</li>
                            <li>• Premium features are temporarily unavailable</li>
                            <li>• We'll notify you when subscriptions are available</li>
                        </ul>
                    </div>
                </div>

                {/* Footer */}
                <div className="flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 font-mono text-sm uppercase tracking-wider transition-all border-none bg-[#1b263b] text-white hover:opacity-60"
                    >
                        Got it
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionDisabledModal;
